module.exports = __webpack_public_path__ + "img/no-msg.e6f51e34.png";